"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageFill = exports.ImageFillDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
exports.ImageFillDefaultProps = {
  fit: 'cover'
};
// -------- Styles -------->
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    border: none;\n    box-sizing: border-box;\n    \n    ", "\n\n    ", "\n    "], ["\n    border: none;\n    box-sizing: border-box;\n    \n    ", "\n\n    ", "\n    "])), function (_a) {
    var fit = _a.fit;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      object-fit: ", ";\n    "], ["\n      object-fit: ", ";\n    "])), fit);
  }, function (props) {
    return !props.isVisible && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])));
  })
});
// -------- Components -------->
var My = {
  Image: styled_components_1.default.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles)
};
var ImageFill = function (props) {
  var className = props.className,
    entity = props.entity,
    alt = props.alt,
    onClick = props.onClick,
    fit = props.fit,
    title = props.title;
  var _a = __read((0, react_1.useState)(true), 2),
    isVisible = _a[0],
    setIsVisible = _a[1];
  var onError = function () {
    setIsVisible(false);
  };
  return react_1.default.createElement(My.Image, {
    key: entity.url,
    isVisible: isVisible,
    onError: onError,
    title: title,
    fit: fit,
    onClick: onClick,
    className: className,
    alt: alt,
    src: entity.url
  });
};
exports.ImageFill = ImageFill;
exports.ImageFill.defaultProps = exports.ImageFillDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;